<template>
    <div :class="'form-group js-form-validation__group ' + className">
        <div class="position-relative">
            <FormLabel :label="label" :id="id" :required="required" :class="labelClassName"></FormLabel>

            <div class="custom-select js-custom-select ">
                <input class="js-custom-select__input form-control visually-hidden "
                       :name="name"
                       :id="id"
                       :value="selected"
                       :required="required"
                       @change="onChangeValue($event.target.value, false)"
                       @input="$emit('update:modelValue', $event.target.value)"
                        tabindex="-1">
                <button type="button" class="custom-select__btn js-custom-select__button dropdown-toggle form-control" :data-bs-display="staticBottom ? 'static' : null " data-bs-toggle="dropdown" aria-expanded="false">
                    <span class="custom-select__btn-text js-custom-select__value-label">{{ selectedLabel || placeholder }}</span>
                </button>

                <ul class="custom-select__dropdown dropdown-menu">
                    <li v-for="option in options">
                        <button type="button" class="dropdown-item js-custom-select__item"
                                :class="option.disabled ? 'disabled' : ''"
                                :data-value="option.value"
                                :selected="option.selected">
                          {{ option.label }}
                        </button>
                    </li>
                </ul>
            </div>
        </div>

      <FormErrors :errors="errors"></FormErrors>
  </div>
</template>

<script setup lang="ts">
// @ts-ignore
import { defineProps, defineEmits, onMounted, nextTick, ref } from "vue";
import FormLabel from "../form-elements/includes/FormLabel.vue";
import FormErrors from "../form-elements/includes/FormErrors.vue";
// @ts-ignore
import * as customSelect from "../../../../scripts/custom-select";
import Select from "./Select.vue";

const props = defineProps({
  id: {
    default: null,
    required: true,
    type: String
  },
  required: {
    type: Boolean,
    default: false
  },
  label: {
    type: String,
    required: true,
  },
  labelClassName: {
    type: String,
    required: false,
    default: null
  },
  selectClassName: {
    type: String,
    required: false,
    default: null
  },
  name: {
    type: String,
    required: true,
  },
  description: {
    type: String,
    required: false
  },
  options: {
    default: [],
    type: Array,
    required: false
  },
  selectedOption: {
    type: String,
    required: false,
    default: null
  },
  placeholder: {
    type: String,
    required: false,
    default: ""
  },
  changeValue: {
    type: Function,
    required: false,
    default: null
  },
  className: {
    type: String,
    required: false,
    default: null
  },
  wrapperClassName: {
    type: String,
    required: false,
    default: null
  },
  staticBottom: {
    type: Boolean,
    required: false,
    default: false
  }
});

const emit = defineEmits(['changeValue', 'update:modelValue']);
const errors = [];

const selected = ref(props.selectedOption || null);
const selectedLabel = ref('');

const onChangeValue = (e: string, isFirstUpdate: boolean) => {
  selected.value = e;
  emit('changeValue', e, isFirstUpdate);
};

onMounted(() => {
  nextTick(customSelect.init());
  //set selectedOption to first option if no option is selected
  if(!props.selectedOption && props.options.length !== 0){
    //if one of the options is selected, set selected to this option
    if(props.options.some((option) => option.selected)){
      const option = props.options.find((option) => option.selected);
      emit('update:modelValue', option.value);
      onChangeValue(option.value, true);
      selected.value = option.value;
      selectedLabel.value = option.label;

    }else{
      if(props.placeholder){
        selectedLabel.value = props.placeholder;
      }else{
        emit('update:modelValue', props.options[0].value);
        onChangeValue(props.options[0].value, true);
        selected.value = props.options[0].value;
        selectedLabel.value = props.options[0].label;
      }
    }
  }
})

</script>
